import Vue from "vue";
import VueRouter from "vue-router";

import HomePage from "@/pages/Home.vue";
import Listing from '@/pages/Listing.vue';

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "Home", component: HomePage },
  {path:'/listing/:fakename/:id', name:'listing', component: Listing}
];

export default new VueRouter({
  routes: routes,
});

